"use client";

import { useEffect, useState } from "react";

const STORAGE_KEY = "satlabs-privacy-ack";

// Compartilhado entre PrivacyNotice e WhatsAppFloat: os dois precisam saber
// se o aviso de cookies está na tela (o aviso ocupa quase a largura toda no
// mobile e ficava embaixo do botão flutuante, cobrindo ele por completo).
export function usePrivacyNoticeVisible(): boolean {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(STORAGE_KEY)) return;

    const showId = setTimeout(() => setVisible(true), 800);

    function onStorage(e: StorageEvent) {
      if (e.key === STORAGE_KEY && e.newValue) setVisible(false);
    }
    // storage event só dispara entre abas diferentes — dentro da mesma aba,
    // o próprio PrivacyNotice também escreve no localStorage ao aceitar, e
    // usamos um evento customizado pra avisar este hook na hora.
    function onAck() {
      setVisible(false);
    }
    window.addEventListener("storage", onStorage);
    window.addEventListener("satlabs:privacy-ack", onAck);
    return () => {
      clearTimeout(showId);
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("satlabs:privacy-ack", onAck);
    };
  }, []);

  return visible;
}

export function markPrivacyNoticeAcknowledged() {
  localStorage.setItem(STORAGE_KEY, "1");
  window.dispatchEvent(new Event("satlabs:privacy-ack"));
}
